import { ESwipeModalMode, ISwipeModalGestures } from '../types';

const GESTURES_BY_MODE: Record<ESwipeModalMode, ISwipeModalGestures> = {
  [ESwipeModalMode.HALF]: { closeOnSwipeDown: true, expandOnSwipeUp: true },
  [ESwipeModalMode.FULL]: { closeOnSwipeDown: false, expandOnSwipeUp: false },
  [ESwipeModalMode.CONTENT]: { closeOnSwipeDown: true, expandOnSwipeUp: false },
};

export function getSwipeModalGestures(mode: ESwipeModalMode): ISwipeModalGestures {
  return GESTURES_BY_MODE[mode];
}
